import React, { useEffect, useState } from 'react';
import './Factura.css';

const VerFactura = ({ idCita, idTicket, onCancelarImpresion }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const [factura, setFactura] = useState(null);
  const [error, setError] = useState(null);
  const [cargando, setCargando] = useState(true);
  const IVA_PORCENTAJE = 0.21;

  useEffect(() => {
    const cargarFactura = async () => {
      try {
        setCargando(true);
        let url = null;

        if (idTicket) {
          url = `${apiUrl}/api/getticketventadirecta/${idTicket}`;
        } else if (idCita) {
          url = `${apiUrl}/api/ticketcita/${idCita}`;
        }

        if (!url) throw new Error('No se proporcionó ni idTicket ni idCita');

        const response = await fetch(url);
        if (!response.ok) throw new Error('No se pudo obtener el ticket');

        const data = await response.json();
        setFactura(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setCargando(false);
      }
    };

    if (idTicket || idCita) cargarFactura();
  }, [idTicket, idCita, apiUrl]);

  const formatPrecio = (precio) => {
    const num = parseFloat(precio);
    return isNaN(num) ? '0.00' : num.toFixed(2);
  };

  const calcularTotales = () => {
    if (!factura?.detalles) return { subtotal: '0.00', iva: '0.00', total: '0.00' };
    const total = factura.detalles.reduce((acc, item) => acc + parseFloat(item.precio || 0), 0);
    const subtotal = total / (1 + IVA_PORCENTAJE);
    const iva = total - subtotal;

    return {
      subtotal: subtotal.toFixed(2),
      iva: iva.toFixed(2),
      total: total.toFixed(2),
    };
  };

  const hayTicket = factura?.detalles?.length > 0;

  const imprimirTicket = async () => {
    const ticketData = {
      fecha: new Date(factura.fecha).toLocaleString('es-ES'),
      id_ticket: factura.id_ticket || 'N/A',
      cliente: `${factura.nombre_cliente} ${factura.apellidos_cliente}`,
      detalles: factura.detalles.map(item => ({
        nombre: item.nombre || 'Concepto no especificado',
        precio: parseFloat(item.precio || 0),
      })),
      subtotal: calcularTotales().subtotal,
      iva: calcularTotales().iva,
      total: calcularTotales().total,
      totalDescuento: factura.resumen?.totalDescuento || 0, // <-- incluido
      tipo_pago: factura.tipo_pago || 'No especificado',
    };

    console.log("Datos que se envían para impresión:", ticketData);

    try {
      const response = await fetch('http://localhost:8000/imprimir', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ticket: ticketData }),
      });

      if (!response.ok) throw new Error('Error al enviar los datos al servidor');
      const result = await response.json();
      alert(result.mensaje || 'Ticket enviado correctamente para impresión');
    } catch (error) {
      alert(`Error: ${error.message}`);
    }
  };

  if (cargando) return <div className="cargando-ticket">Cargando información del ticket...</div>;
  if (error) return <div className="error-ticket">{error}</div>;

  return (
    <div className="ver-factura-container">
      {!hayTicket ? (
        <p className="sin-ticket">No hay ticket disponible para esta cita</p>
      ) : (
        <div className="ticket-termico">
          <div className="ticket-header">
            <h1>FLASH ESTILISTAS</h1>
            <p>Flash Peluquería, C. de Blas Cabrera, 125<br />Mercado las águilas 28044 Madrid</p>
            <p>Tel: 641266877</p>
          </div>

          <div className="ticket-info">
            <p><strong>Fecha:</strong> {new Date(factura.fecha).toLocaleString('es-ES')}</p>
            <p><strong>Ticket #:</strong> {factura.id_ticket || 'N/A'}</p>
            <p><strong>Cliente:</strong> {factura.nombre_cliente} {factura.apellidos_cliente}</p>
          </div>

          <div className="ticket-divider">--------------------------------</div>

          <div className="ticket-items">
            <div className="ticket-item-header">
              <span>CONCEPTO</span>
              <span>PRECIO</span>
            </div>
            {factura.detalles.map((item, index) => (
              <div key={index} className="ticket-item">
                <span>{item.nombre || 'Concepto no especificado'}</span>
                <span>€{formatPrecio(item.precio)}</span>
              </div>
            ))}
          </div>

          <div className="ticket-divider">--------------------------------</div>

          <div className="ticket-totals">
  <div className="ticket-total-line">
    <span>Subtotal:</span>
    <span>€{calcularTotales().subtotal}</span>
  </div>
  <div className="ticket-total-line">
    <span>IVA (21%):</span>
    <span>€{calcularTotales().iva}</span>
  </div>
  <div className="ticket-total-line total">
    <span>TOTAL:</span>
    <span>€{calcularTotales().total}</span>
  </div>

{factura.totalDescuento != null && factura.totalDescuento > 0 && (
  <div className="ticket-total-line descuento">
    <span>TOTAL CON DESCUENTO:</span>
    <span>€{parseFloat(factura.totalDescuento).toFixed(2)}</span>
  </div>
)}
</div>


          <div className="payment-method">
            <span><strong>Método de pago:</strong> {factura.tipo_pago || 'No especificado'}</span>
          </div>

          <div className="ticket-footer">
            <p>¡Gracias por su visita!</p>
            <p>*** Vuelva pronto ***</p>
          </div>

          <div className="botones-accion-ticket">
            <button onClick={imprimirTicket} className="btn-imprimir">Imprimir Ticket</button>
            <button onClick={onCancelarImpresion} className="btn-noimprimir">No imprimir</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default VerFactura;
